import Vue from "vue";
import numeral from "numeral";
import { formatDate, formatDateLocal } from "@/helpers/dates";

Vue.filter(
  "date",
  (value, format = "DD-MMM-YYYY HH:mm", returnValue = "N/A") => {
    if (!value) return returnValue;
    return formatDate(value, format);
  }
);

Vue.filter(
  "dateLocal",
  (value, format = "DD-MMM-YYYY HH:mm", returnValue = "N/A") => {
    if (!value) return returnValue;
    return formatDateLocal(value, format);
  }
);

Vue.filter("numeral", (value, format = "0,0") => {
  return numeral(value).format(format);
});

Vue.filter("toUpperCase", (value) => {
  return (typeof value === 'string') ? value.toUpperCase() : '';
});